import React, { Component } from "react";

class Default extends Component {
  render() {
    return (
      <div>
        <h1>Page not Found</h1>
      </div>
    );
  }
}

export default Default;
